module.exports = __webpack_public_path__ + "img/sanya.48c6837b.jpg";